import React from 'react';
import { Switch, Redirect } from 'react-router-dom';

/**
 * Hidden routes: old Mailchimp URLs → /dashboard/emails/* after menu flatten.
 */
const MailchimpPathRedirects = () => (
  <Switch>
    <Redirect exact from="/dashboard/mailchimp/emails/new" to="/dashboard/emails/new" />
    <Redirect exact from="/dashboard/mailchimp/emails/old" to="/dashboard/emails/old" />
    <Redirect exact from="/dashboard/mailchimp/emails" to="/dashboard/emails/old" />
    <Redirect from="/dashboard/mailchimp" to="/dashboard/emails/old" />
  </Switch>
);

export default MailchimpPathRedirects;
